<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0" :adelanteVisible="mostrarAdelante" @update:currentText="currentText = $event"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout wrap row justify-center align-center text-xs-center class="cont_page" mt-3>
          <v-flex xs12 sm7 md7>
              <youtube video-id="hIG-IFWZxbs" @ended="mostrarAdelante = true" width="100%" height="200px"></youtube>
              <figcaption>Português ao Vivo - Cumprimentos - Parte 1 – Utilizado no Material de Apoio Português 01 do IBRACO.</figcaption>
          </v-flex>
        </v-layout>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Clique no vídeo abaixo para saber como os brasileiros se cumprimentam.',
        'Agora, clique em avançar.'
      ],
      mostrarAdelante:false,
      currentText:0
    }
  },
  watch: {
    currentText(){
      setTimeout(() => {
        this.$store.commit('nextShow', true);
      }, 1000);
    }
  }
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';

</style>
